import React from "react";
import PropTypes from "prop-types";
import OrgChartContextProvider from "./context/OrgChartContextProvider";
import TeamVisualiser from "./components/TeamVisualiser";

const OrgChart = ({ teamId }) => {
  return (
    <OrgChartContextProvider teamId={teamId}>
      <TeamVisualiser />
    </OrgChartContextProvider>
  );
};

OrgChart.propTypes = {
  teamId: PropTypes.string,
};

export default React.memo(OrgChart);
